export const TrashIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fill="currentColor"
        d="M6.477 21.15q-.71 0-1.21-.498a1.64 1.64 0 0 1-.5-1.206V5.298h-.274a.82.82 0 0 1-.606-.247.83.83 0 0 1-.246-.61q0-.36.246-.604a.83.83 0 0 1 .606-.243h4.105a.83.83 0 0 1 .246-.612.82.82 0 0 1 .606-.245h5.094q.36 0 .606.249a.83.83 0 0 1 .246.608h4.11q.361 0 .607.247a.83.83 0 0 1 .246.61.82.82 0 0 1-.246.605.83.83 0 0 1-.606.242h-.275v14.148q0 .71-.5 1.206a1.65 1.65 0 0 1-1.21.497zM17.523 5.297H6.477v14.148h11.046zm-7.62 12.046a.77.77 0 0 0 .568-.231.78.78 0 0 0 .228-.567v-8.38a.77.77 0 0 0-.233-.566.78.78 0 0 0-.57-.231q-.345 0-.571.232a.78.78 0 0 0-.228.566v8.38a.77.77 0 0 0 .232.566.78.78 0 0 0 .573.231m4.207 0a.77.77 0 0 0 .568-.231.77.77 0 0 0 .23-.567v-8.38a.77.77 0 0 0-.234-.566.79.79 0 0 0-.573-.231.77.77 0 0 0-.57.232.77.77 0 0 0-.23.566v8.38q0 .334.236.566a.8.8 0 0 0 .573.231"
      />
    </svg>
  );
};
